













































import Vue from 'vue'
import { defineComponent } from '@vue/composition-api'
import { addPage, currentPage, setCurrentPage, Page, updatePages, copyPage } from '@/assets/page'
import { project } from '@/assets/project'
import { setState as setCodeEditState } from '@/assets/code-edit'
import { Notification } from 'element-ui'

export default defineComponent({
  setup () {
    return {
      project,
      currentPage,
      addPage,

      setSelect (item: Page) {
        setCurrentPage(item)
        setCodeEditState(false)
      },

      handleSetIndex (item: Page) {
        const oldIndexPage = project.pages.find(x => x.isIndex)
        if (oldIndexPage) {
          updatePages({ pageId: oldIndexPage.id }, { isIndex: false })
        }
        updatePages({ pageId: item.id }, { isIndex: true })
        Notification({
          title: '成功',
          type: 'success',
          message: '设置首页成功',
          position: 'top-right',
          duration: 2000
        })
      },

      handleCopy (item: Page) {
        localStorage.setItem('butterfly-copy-page', JSON.stringify(item))
        Vue.prototype.$notice('复制页面到剪切板成功')
      },

      async copyPage () {
        const local = localStorage.getItem('butterfly-copy-page')
        if (local) {
          try {
            const localParse = JSON.parse(local)
            await Vue.prototype.$msgbox.confirm(`即将粘贴剪切板页面：${localParse.title || localParse.id}，确定吗？`)
            copyPage(localParse)
          } catch (e) {
            Vue.prototype.$notice('剪切板无有效的复制页面', true)
          }
        } else {
          Vue.prototype.$notice('剪切板无复制的页面', true)
        }
      }
    }
  }
})
